
<div class="createdApiKey mt-3 w-4/5 mx-auto"
 *ngIf="createApiKeyResult">
  <div class="flex flex-row bg-[#DAFF00] h-12 rounded-t-md">
    <div class="basis-1/2 flex flex-row items-center ml-3 font-medium">
      API-Key erstellt
    </div>
    <div class="basis-1/2 flex flex-row justify-end items-center">
      <div class="close cursor-pointer transform rotate-45 mr-4 text-lg" (click)="closeCreatedApiKey()">+</div>
    </div>
  </div>
  <div class="details-content">
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">API Key-ID:</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span>{{createApiKeyResult.apiKeyId}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'API-Key-ID kopieren'"
          (click)="copyToClipboard(createApiKeyResult.apiKeyId)"
          [icon]="'icon-copy'">
        </nx-default-button>
      </div>
    </div>
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">API Key:</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span>{{createApiKeyResult.apiKeyData}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'API-Key kopieren'"
          (click)="copyToClipboard(createApiKeyResult.apiKeyData)"
          [icon]="'icon-copy'">
        </nx-default-button>
      </div>
    </div>
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label font-medium">Der API-Key wird nur einmal angezeigt und kann nicht wiederhergestellt werden.
        Bitte speichere ihn an einem sicheren Ort ab. Bei Verlust muss ein neuer API-Key erstellt werden.</div>
    </div>
  </div>
</div>

<div class="details mt-3">
  <div class="flex flex-row bg-[#EAEEEF] h-12 rounded-t-md">
    <div class="basis-1/2 flex flex-row items-center ml-3 font-medium text-[1rem]">
      Allgemein
    </div>
    <div class="basis-1/2 flex flex-row justify-end items-center">
    </div>
  </div>
  <div class="details-content">
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">API-Endpoint:</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span>{{environment.apiUri}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'API-Endpoint kopieren'"
          (click)="copyToClipboard(environment.apiUri)"
          [icon]="'icon-copy'">
        </nx-default-button>
      </div>
    </div>
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">API-Dokumentation:</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span>{{environment.documentationUri}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'Dokumentation öffnen'"
          (click)="openDocumentation()"
          [icon]="'icon-link'">
        </nx-default-button>
      </div>
    </div>
    <div class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-1/3 font-medium">Tenant-ID:</div>
      <div class="flex basis-2/3 justify-end items-center">
        <span>{{currentTenantId}}</span>
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'Tenant-ID kopieren'"
          (click)="copyToClipboard(currentTenantId)"
          [icon]="'icon-copy'">
        </nx-default-button>
      </div>
    </div>
  </div>
</div>

<app-uploader-state-view></app-uploader-state-view>

<nx-table-header
  class="text-[1rem]"
  label="API-Key-Liste">
  <ng-template nxTemplate="end">
    <nx-default-button
      *ngIf="rolesService?.hasRole('framework_developer_manage')"
      (click)="createApiKey()"
      [style]="'light'"
      [label]="'API-Key erstellen'"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>

<p-table
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  scrollHeight="flex"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} von {totalRecords}"
  [resizableColumns]="true">
    <ng-template pTemplate="caption">
      <div class="flex flex-row">
        <div class="basis-2/3 flex flex-row gap-2">
          <!-- no filter -->
        </div>
        <div class="basis-1/3 flex flex-row justify-end">
          <p-dropdown
            placeholder="Sortierung"
            [styleClass]="'sort'"
            appendTo="body"
            [ngModel] = "sortModel"
            [options]="sortOptions"
            optionLabel="label"
            [showClear]="false"
            (onChange)="sort($event)">
          </p-dropdown>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
          <th>Key-ID</th>
          <th>Zuletzt benutzt</th>
          <th>Kommentar</th>
          <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-apiKey>
        <tr>
            <td style="min-width:7.5rem">
              {{apiKey?.id? apiKey.id : '-'}}
              <nx-default-button
                [style]="'light'"
                class="ml-2"
                [tooltip]="'API-Key-ID kopieren'"
                (click)="$event.stopPropagation(); copyToClipboard(apiKey.id)"
                [icon]="'icon-copy'">
              </nx-default-button>
            </td>
            <td>
              {{apiKey?.lastUsedDateTime? (apiKey.lastUsedDateTime | date:'dd.MM.yyyy HH:mm') + ' Uhr': '-'}}
            </td>
            <td>
              {{apiKey?.comment? apiKey.comment : '-'}}
            </td>
            <td class="text-right" style="min-width:5rem">
              <nx-default-button
                *ngIf="rolesService?.hasRole('framework_developer_manage')"
                [style]="'dark'"
                class="ml-2"
                [tooltip]="'API-Key-ID löschen'"
                (click)="$event.stopPropagation(); deleteApiKey(apiKey)"
                [label]="'löschen'">
            </nx-default-button>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="emptyMessage">Keine Api-Keys vorhanden.</td>
      </tr>
    </ng-template>
</p-table>
